import { render, staticRenderFns } from "./addProjectForm.vue?vue&type=template&id=59a25b4d"
import script from "./addProjectForm.vue?vue&type=script&lang=js"
export * from "./addProjectForm.vue?vue&type=script&lang=js"
import style0 from "./addProjectForm.vue?vue&type=style&index=0&id=59a25b4d&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports